<template>
  <div class="chess-game">
    <VueChessboard
      :fen="fen"
      :orientation="orientation"
      @move="onMove"
    />
    <div v-if="gameOver" class="result">
      <p>{{ resultMessage }}</p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Chess } from 'chess.js'
import VueChessboard from 'vue3-chessboard'
import 'vue3-chessboard/style.css' // Importa o estilo necessário

const game = new Chess()

const fen = ref(game.fen())
const orientation = ref('white') // troque para 'black' dependendo do jogador
const gameOver = ref(false)
const resultMessage = ref('')

function onMove({ from, to }) {
  const move = game.move({ from, to, promotion: 'q' })
  if (move) {
    fen.value = game.fen()
    checkGameOver()
  }
}

function checkGameOver() {
  if (game.game_over()) {
    gameOver.value = true

    if (game.in_checkmate()) {
      resultMessage.value = game.turn() === 'w'
        ? 'Vitória das pretas!'
        : 'Vitória das brancas!'
    } else {
      resultMessage.value = 'Empate!'
    }

    // aqui você pode notificar o backend
  }
}
</script>

<style scoped>
.chess-game {
  width: 100%;
  max-width: 800px;
  margin: 2rem auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.result {
  margin-top: 1rem;
  font-weight: bold;
  font-size: 1.2rem;
  color: #333;
}
</style>
